import { db } from "../../config/firebaseconfig";
import getTruthyKeys from "../getTruthyKeys";
import parseSnapshot from "../parseSnapshot";

export default function markGUAsAsNeedingUpdate (student, assessmentId, year) {
  if (!student) return Promise.reject()
  
  function findTeachersWithClasses(educatorsSnapshot, classes) {
    let teachersWithClasses = {}
    const educators = Object.values(parseSnapshot(educatorsSnapshot))
    educators.forEach(educator => {
      if (!educator.classes) return
      classes.forEach(cl => {
        if (educator.classes[cl]) {
          teachersWithClasses[educator.id] = true
        }
      })
    })
    return teachersWithClasses
  }

  const classes = getTruthyKeys(student.classes)
  return db.collection('educators').where('school', '==', student.school).get()
    .then(educatorsSnapshot => {
      const teachers = Object.keys(findTeachersWithClasses(educatorsSnapshot, classes))
      const groupUAIds = [
        student.schoolDistrict,
        student.school,
        ...classes,
        ...teachers,
      ]
      const updates = groupUAIds.map(groupUAId => {
        const updateKey = `sy${year}.${assessmentId}.upToDate`
        return db.collection('groupUA').doc(groupUAId).update({[updateKey]: false})
      })
      return Promise.all(updates)
    })


}


// WEBPACK FOOTER //
// ./src/helpers/assessment/markGUAsAsNeedingUpdate.js